'use strict'

import angular from 'angular'

import buySheetNavComponentHtmlUrl from './buySheetNav.component.html'

angular.module('buySheet.components').component('buySheetNav', {
    templateUrl: buySheetNavComponentHtmlUrl,
    bindings: {
        orderId: '<',
        mayExportBuySheetToExcel: '<',
        buySheetConfigsIds: '<'
    },
    controller() {
        this.sectionToShow = 'loading'

        this.$onInit = () => {
            this.selectedConfigId = this.buySheetConfigsIds[0]
        }

        this.selectBuySheetFor = (configId) => {
            this.selectedConfigId = configId
        }
    },
    controllerAs: 'vm'
})